module.exports = __webpack_public_path__ + "static/projekt_indywidualny_b3-a0da661bc8339842ea571864c23db59f.jpg";